import PropTypes from "prop-types"
import React from "react"

class SafeHarborToggle extends React.Component {
  constructor(props) {
    super(props)
    this.no = this.no.bind(this)
    this.yes = this.yes.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("Safe Harbor Membership")
  }

  no() {
    this.props.setGlobalState({ choseBrewer: false })
    this.props.routeTo("next")
  }

  yes() {
    this.props.setGlobalState({ choseBrewer: true })
    this.props.routeTo("SafeHarbor")
  }

  render() {
    return (
      <div id="safeHarborToggle" className="boatus-toggle">
        <h3 className="text-center text-lg">
          Do you have a Safe Harbor Membership?
        </h3>
        <div style={{ marginTop: "10px" }} className="btn-group" role="group">
          <button
            id="safeHarborYesSelection"
            autoFocus
            className="btn btn-primary"
            type="button"
            onClick={this.yes}
          >
            Yes
          </button>
          <button
            id="safeHarborNoSelection"
            className="btn btn-secondary"
            type="button"
            onClick={this.no}
          >
            No
          </button>
        </div>
        <p style={{ marginTop: "15px" }}>
          If you are a Safe Harbor member, you can add your membership
          information to get discounts at this location.
        </p>
      </div>
    )
  }
}

SafeHarborToggle.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
}

export default SafeHarborToggle
